import React from 'react';
import range from 'lodash/fp/range';
import { SkeletonItem } from '@atlaskit/menu';
import { MenuListItem } from '@atlaskit/navigation-system';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { fg } from '@atlassian/jira-feature-gating';
import type { SkeletonNavMenuItemsProps } from './types.tsx';

export const SkeletonNavMenuItems = ({ count = 5 }: SkeletonNavMenuItemsProps) =>
	fg('blu-7837_apply_presstrace_nav4') ? (
		<UFOLoadHold name="nav4-sidebar-menu-items-loading">
			{range(0, count).map((index) => (
				<MenuListItem key={index}>
					<SkeletonItem isShimmering />
				</MenuListItem>
			))}
		</UFOLoadHold>
	) : (
		range(0, count).map((index) => (
			<MenuListItem key={index}>
				<SkeletonItem isShimmering />
			</MenuListItem>
		))
	);
